"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedPersonalDetailsPage = void 0;
var react_1 = __importStar(require("react"));
var personal_details_1 = require("./personal_details");
var next_of_kin_details_1 = require("./next_of_kin_details");
var react_router_dom_1 = require("react-router-dom");
var complete_1 = require("./complete");
var AdvancedPersonalDetailsPage = function () {
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "flex flex-col gap-8" },
        react_1.default.createElement(react_router_dom_1.Routes, null,
            react_1.default.createElement(react_router_dom_1.Route, { path: "/", element: react_1.default.createElement(personal_details_1.PersonalDetailsPage, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/personal-details", element: react_1.default.createElement(personal_details_1.PersonalDetailsPage, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/family-details", element: react_1.default.createElement(next_of_kin_details_1.NextOfKinDetailsPage, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "/complete", element: react_1.default.createElement(complete_1.CompletePage, null) }))));
};
exports.AdvancedPersonalDetailsPage = AdvancedPersonalDetailsPage;
